import {lazy} from 'react';
import makeGetDoesAdyenV2SubTypeRequireGenericBillingAddress
from '../../../v2/selectors/PaymentOptionSelectors/AdyenV2/makeGetDoesAdyenV2SubTypeRequireGenericBillingAddress';
import getAdyenV2PaymentOptionMessage from './getAdyenV2PaymentOptionMessage';
import getIcon from './paymentOptionSvgs';

const LazyGenericBillingAddressPaymentOptionContents = lazy(() => import('./AdyenV2/GenericBillingAddressPaymentOptionContents' /* webpackChunkName: 'GenericBillingAddressPaymentOptionContents' */));

export const getAdyenV2PaymentOptionAttributes = (adyenV2PaymentOptionType, adyenV2PaymentOptionId, state) => {
  const iconObject = getIcon(`ADYEN_V2--${adyenV2PaymentOptionType}`);
  
  let svgPaymentType = adyenV2PaymentOptionType;
  
  if (adyenV2PaymentOptionType === 'scheme') {
    svgPaymentType = 'card';
  }
  
  const contents = makeGetDoesAdyenV2SubTypeRequireGenericBillingAddress(adyenV2PaymentOptionType)(state)
    ? LazyGenericBillingAddressPaymentOptionContents
    : null;
  
  return {
    inputId: `ADYEN_V2--${adyenV2PaymentOptionId}`,
    paymentName: `checkout.payment.method.adyenv2.${adyenV2PaymentOptionType}.name`,
    icons: iconObject.url ? iconObject : {...iconObject, url: `https://checkoutshopper-live.adyen.com/checkoutshopper/images/logos/${svgPaymentType}.svg`},
    alwaysShowTitle: true,
    useFullSizeIconsInArray: true,
    paymentOptionContents: contents,
    getMessage: () => getAdyenV2PaymentOptionMessage(adyenV2PaymentOptionType),
    getShouldHide: () => false,
    getIsDisabled: () => false,
  };
};

export default getAdyenV2PaymentOptionAttributes;
